import React, {Component, Fragment, useEffect, useState} from 'react'
import Counter from "../../../components/counter";
import ProgressBar from "@ramonak/react-progress-bar";

export default function ScreenBarPartner({context,campagneData,mini}){

    const partnerMontant=campagneData?.partnerMontant || 1

    const totalSum=campagneData.stats.total.sum.total
    const total=campagneData.stats.total.sum.total/partnerMontant


    let bonus=null
    let _objectif=campagneData.objectif
    if(_objectif<total && Array.isArray(campagneData?.bonus) && campagneData?.bonus.length>0){
        bonus=campagneData.bonus.find(b=>b>total)
        if(!bonus){
            bonus=campagneData.bonus.at(-1)
        }
    }
    if(bonus){
        _objectif=bonus
    }

    let percent=(_objectif>0 ? (total/_objectif)*100 : 0)
    const displayPercent=(Number(campagneData.objectif)>0 ? (total/campagneData.objectif)*100 : 0)
    let progressColor=campagneData.config?.primaryColor || "#13A0BB"
    let progressLabelColor=campagneData.config?.secondaryColor || "#000"

    let donorName=campagneData.config?.donorName || "Parrainages"

    const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:0 })
    const formater2=new Intl.NumberFormat('de-DE', { style:"currency",maximumFractionDigits:0,currency:"EUR" })


    const accentColor="rgb(103,223,232)"
    const counterColor="#A8243B"


    return (
        <>
            <div style={{position: "absolute", top: "43vh", left: "8vw"}}>
                <div style={{display: "flex"}}>
                    <span style={{
                        textAlign: "center",
                        textTransform: "uppercase",
                        color: "#FFF",
                        fontSize: 40,
                        letterSpacing: 7
                    }}>Dons Récoltés</span>
                </div>

                <div style={{display: "flex", justifyContent: "center", alignItems: "center", marginTop: -10}}>
                    <span style={{
                        textAlign: "center",
                        color: accentColor,
                        fontWeight: "600",
                        fontSize: 90
                    }}>{formater2.format(totalSum)}</span>
                </div>
            </div>


            <div style={{position: "absolute", top: "45vh", right: "5vw"}}>
                <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <span style={{
                        textAlign: "center",
                        textTransform: "uppercase",
                        color: "#FFF",
                        fontSize: 35,
                        letterSpacing: 7
                    }}>Objectif Soirée</span>
                </div>

                <div style={{display: "flex", justifyContent: "center", alignItems: "center", marginTop: -10}}>
                    <span style={{
                        textAlign: "center",
                        color: accentColor,
                        fontWeight: "600",
                        fontSize: 65
                    }}>{formater2.format(_objectif * partnerMontant)}</span>
                </div>
            </div>


            <div style={{
                position: "absolute",
                top: "13vh",
                left: "35vw",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width:"30vw",
                border:"0px solid red"
            }}>
                <span style={{
                    textAlign: "center",
                    color: counterColor,
                    fontWeight: "400",
                    fontSize: 250,
                    letterSpacing: -8,
                }}>{parseInt(total)}</span>

                <span style={{
                    textAlign: "center",
                    color: "#13A0BB",
                    fontWeight: "500",
                    fontSize: 50,
                    marginTop: -80
                }}>{donorName}</span>
            </div>


            <div style={{position: "absolute", top: "69.5vh", left: 0}}>
                <div className={"d-flex align-items-center"}
                     style={{gap: 35, justifyContent: "center", width: "100vw"}}>

                    <span style={{
                        textAlign: "center",
                        textTransform: "uppercase",
                        color: "#FFF",
                        fontSize: 30,
                        letterSpacing: 10
                    }}>Objectif</span>

                    <div style={{padding: 6, border: "2px solid "+accentColor,position:"relative"}}>
                        <div style={{height:"2.5vh",width:"40vw",backgroundColor:accentColor+"33",borderRadius:5,overflow:"hidden",display:"flex",gap:"0.4vw",alignItems:"center"}}>
                            {[...Array(Math.floor(percent/(100/25))).keys()].map(i=>{
                                return(
                                    <div key={i} style={{backgroundColor:accentColor,height:"100%",width:"1.3vw",boxShadow: "0 0 8px "+accentColor}}/>
                                )
                            })}
                        </div>
                    </div>


                    <span style={{
                        textAlign: "center",
                        color: accentColor,
                        fontWeight: "600",
                        fontSize: 50
                    }}>{parseInt(percent)}%</span>

                </div>
            </div>

        </>
    )
}


/*

<div className={"d-flex justify-content-around align-items-center"} style={{flexDirection: "column", gap: 10}}>

                <div>
                    <span className={"screen-count-text2"}><Counter number={total} decimals={0} preserveValue/> {donorName}</span>
                </div>


                <ProgressBar
                    customLabel={<span style={{fontSize:"3.5vh",marginRight:"1vw"}}><Counter number={displayPercent} decimals={0}/>%</span>}
                    animateOnRender
                    completed={percent >= 10 ? percent : 10}
                    width={"70vw"}
                    height={"7vh"}
                    bgColor={"linear-gradient(90deg, rgba(220,171,107,1) 30%, rgba(255,230,197,1) 100%)"}
                    baseBgColor={"rgba(255,255,255,0.2)"}
                    labelColor={progressLabelColor}
                    className="screen-progress-bar"
                />

                <div style={{marginTop:"2vh"}}>
                    <span style={{
                        color:'#FFF',
                        fontSize: "4vh",
                        textTransform:"uppercase",
                    }}>{!bonus && "OBJECTIF"} {bonus && "NOUVEL OBJECTIF"} : {formater.format(campagneData.objectif)} {donorName}</span>
                </div>

            </div>

 */
